import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { StyledTab } from './StyledTab.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["badge", "children", "onRemove", "value"];
var TabsTab = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var badge = _ref.badge,
    children = _ref.children,
    onRemove = _ref.onRemove,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(StyledTab, _objectSpread(_objectSpread({}, rest), {}, {
    badge: badge,
    ref: ref,
    role: "tab",
    onRemove: onRemove ? function (e) {
      e.stopPropagation();
      onRemove(value, e);
    } : void 0,
    children: children
  }));
});
TabsTab.displayName = "TabsTab";
TabsTab.__TYPE = StyledTab.__TYPE;

export { TabsTab };
